function Badge({ label, color = "gray" }) {
  const COLORS = {
    blue: "bg-blue-100 text-blue-800",
    green: "bg-green-100 text-green-800",
    red: "bg-red-100 text-red-800",
    gray: "bg-slate-100 text-slate-700",
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-semibold ${
        COLORS[color] || COLORS.gray
      }`}
    >
      {label}
    </span>
  );
}

export default Badge;



// function Badge({ label, color }) {
//   const bgColor = color === "blue" ? "bg-blue-100 text-blue-800" : "bg-red-100 text-red-800";
//   return (
//     <span className={`px-2 py-1 rounded-full text-xs font-semibold ${bgColor}`}>
//       {label}
//     </span>
//   );
// }

// export default Badge;
